module.exports = __webpack_public_path__ + "static/media/design-guide-photo-1.a7e01cb7.PNG";